module.exports = __webpack_public_path__ + "static/media/graduation-cap.8b04ebab.svg";